import { Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { FoodsToggleButton, FoodsToggleButtonType } from "@foodpilot/foods";
import { ActionPlanTrajectoryTabs, OneInLocalStorage } from "src/services/OneFromLocalStorage";
import { TabHeader } from "../TabHeader";

type SynthesisProps = {
    selectedButton: ActionPlanTrajectoryTabs;
};
export const SynthesisLayout = (props: SynthesisProps) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { actionPlan, urls } = useActionsContext();

    const doesActionPlanExists = actionPlan !== null;
    if (doesActionPlanExists === false) {
        return <Navigate to={urls.planning()} replace />;
    }

    const buttons: FoodsToggleButtonType[] = [
        {
            id: 1,
            endIcon: "graph",
            onClick: () => {
                OneInLocalStorage.setItem("actionPlan-trajectory-tabs", "barChart");
                const url = urls.trajectoryBarChart();
                navigate(url);
            },
        },
        {
            id: 2,
            endIcon: "gridView",
            onClick: () => {
                OneInLocalStorage.setItem("actionPlan-trajectory-tabs", "cards");
                const url = urls.trajectoryCards();
                navigate(url);
            },
        },
    ];
    const initialButton = props.selectedButton === "barChart" ? buttons[0] : buttons[1];

    return (
        <Stack gap={theme.spacing(3)} flexDirection={"column"} width={"100%"}>
            <Stack flexDirection="row" justifyContent={"space-between"}>
                <TabHeader title={t("actionPlan.trajectory.pageTitle")} />
                <Stack>
                    {buttons.length > 0 && (
                        <FoodsToggleButton
                            buttons={buttons}
                            initialSelected={initialButton ?? buttons[0]}
                            buttonGroup
                        />
                    )}
                </Stack>
            </Stack>
            <Stack>
                <Outlet />
            </Stack>
        </Stack>
    );
};
